// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import prjEntity from './entities/prj.json';
import prjMenu from '../pages/prj/menu.json';
import prjFullForm from '../pages/prj/forms/full.json';
import prjContextForm from '../pages/prj/forms/context.json';
import prjMiniForm from '../pages/prj/forms/mini.json';
import prjLookupForm from '../pages/prj/forms/lookup.json';
import prjTableView from '../pages/prj/views/table.json';
import prjStagesView from '../pages/prj/views/stages.json';
import prjCardsView from '../pages/prj/views/cards.json';
import prjInlineView from '../pages/prj/views/inline.json';
import prjBacklogView from '../pages/prj/views/backlog.json';
import prjSplitView from '../pages/prj/views/split.json';
import prjCalendarView from '../pages/prj/views/calendar.json';
import prjDashboardView from '../pages/prj/views/dashboard.json';

/** Тип запису «Проєкт» зі сторінками пакета: меню, форми та подання з pages/prj/. */
export const prjDefinition: IRecordTypeDefinition = {
  ...prjEntity,
  views: assembleViewSet({
      table: prjTableView,
      stages: prjStagesView,
      cards: prjCardsView,
      inline: prjInlineView,
      backlog: prjBacklogView,
      split: prjSplitView,
      calendar: prjCalendarView,
      dashboard: prjDashboardView,
  }),
  form: prjFullForm,
  forms: { full: prjFullForm, context: prjContextForm, mini: prjMiniForm, lookup: prjLookupForm },
  menu: prjMenu,
} as IRecordTypeDefinition;
